import { FC, memo, PropsWithChildren } from "react";
import "./panel-description.scss";

const PanelDescriptionComponent: FC<PropsWithChildren> = ({ children }) => {
  return <p className="panel-description">{children}</p>;
};

export const PanelDescription = memo(PanelDescriptionComponent);
